import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Hook to check if the ?noguard parameter is present in the URL.
 * This parameter disables route guards and uses mock data for development.
 */
export function useNoGuard(): boolean {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return searchParams.has('noguard');
}

/**
 * Hook that provides a navigate function that preserves noguard parameter
 */
export function useNoGuardNavigate() {
  const navigate = useNavigate();
  const location = useLocation();
  
  return useCallback((to: string, options?: any) => {
    const path = preserveNoGuard(to, location.search);
    navigate(path, options);
  }, [navigate, location.search]);
}

/**
 * Helper to preserve noguard parameter when navigating
 */
export function preserveNoGuard(path: string, currentSearch: string): string {
  const currentParams = new URLSearchParams(currentSearch);
  const hasNoGuard = currentParams.has('noguard');
  
  if (!hasNoGuard) return path;
  
  const [pathname, search] = path.split('?');
  const newParams = new URLSearchParams(search);
  newParams.set('noguard', '');
  
  return `${pathname}?${newParams.toString()}`;
}